/**
 * gridArrowUpContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled grid arrow up container.
 */
const GridArrowUpContainer = styled.div`
  position: absolute;
  bottom: ${20 * Screen.widthRatio}px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default GridArrowUpContainer;
